import { render, staticRenderFns } from "./SocialSecurityProvidentFundPolicy.vue?vue&type=template&id=0c5ddc6a&scoped=true&"
import script from "./SocialSecurityProvidentFundPolicy.vue?vue&type=script&lang=js&"
export * from "./SocialSecurityProvidentFundPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ddc6a",
  null
  
)

export default component.exports